import { useMemo } from 'react';
import {
  getInvalidProposalDisplayMessage,
  type DomainInvalidReason,
  type ProposalValidity,
} from '@mls-wallet/shared-types';

type ProposalWithValidity = {
  proposal: {
    id: string;
    validity: ProposalValidity;
    domainInvalidReason?: DomainInvalidReason;
  };
};

export function useSelectedInvalidProposal<
  TProposal extends ProposalWithValidity,
>(proposals: readonly TProposal[], selectedProposalIds: readonly string[]) {
  // Case: Any selected invalid proposal makes the approval action reject-only.
  const selectedInvalidProposal = useMemo(
    () =>
      proposals.find(
        (proposal) =>
          selectedProposalIds.includes(proposal.proposal.id) &&
          proposal.proposal.validity !== 'valid'
      ),
    [proposals, selectedProposalIds]
  );
  const selectedHasInvalidProposal = Boolean(selectedInvalidProposal);
  const approveDisabledReason = selectedInvalidProposal
    ? getInvalidProposalDisplayMessage(
        selectedInvalidProposal.proposal.domainInvalidReason
      )
    : undefined;

  return {
    selectedInvalidProposal,
    selectedHasInvalidProposal,
    approveDisabledReason,
  };
}
